import { AuthRepository } from "../../domain/repositories/AuthRepository";
import {
  AuthResultEntity,
  LoginCredentials,
} from "../../domain/entities/AuthResult";
import { UserEntity } from "../../domain/entities/User";
import { loginApi, logoutApi } from "../api/authApi";
import { AuthMapper } from "../mappers/AuthMapper";
import {
  storeToken,
  getToken,
  removeToken,
  storeUser,
  getUser,
  removeUser,
  isAuthenticated as checkIsAuthenticated,
} from "../../../../shared/data/storage/authStorage";

/**
 * Auth Repository Implementation
 */
export class AuthRepositoryImpl implements AuthRepository {
  async login(credentials: LoginCredentials): Promise<AuthResultEntity> {
    const response = await loginApi({
      email: credentials.email,
      password: credentials.password,
    });

    const authResult = AuthMapper.toAuthResult(response);

    // Store in localStorage
    storeToken(authResult.token);
    storeUser({
      id: authResult.user.id.toString(),
      email: authResult.user.email,
      isMasterAdmin:
        authResult.user.is_master_admin === true ||
        authResult.user.is_master_admin === "1",
      userName: authResult.user.userName || "",
      role:
        authResult.user.is_master_admin === true ||
        authResult.user.is_master_admin === "1"
          ? "master_admin"
          : "user",
      isActive: authResult.user.is_active || false,
      dateCreated: authResult.user.created_at || new Date().toISOString(),
      dateLastLoggedIn: null,
      passwordChangedAt: authResult.user.password_changed_at || null,
    });

    return authResult;
  }

  async logout(): Promise<void> {
    await logoutApi();
    removeToken();
    removeUser();
  }

  getStoredToken(): string | null {
    return getToken();
  }

  getStoredUser(): UserEntity | null {
    const stored = getUser();
    if (!stored) return null;

    // Ensure is_master_admin is a boolean
    const isMasterAdmin =
      stored.isMasterAdmin === true || stored.role === "master_admin";

    return {
      id: parseInt(stored.id),
      email: stored.email,
      userName: stored.userName,
      is_active: stored.isActive,
      is_master_admin: isMasterAdmin,
      password_changed_at: stored.passwordChangedAt || null,
      created_at: stored.dateCreated,
    };
  }

  isAuthenticated(): boolean {
    return checkIsAuthenticated();
  }
}
